import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { PostHogProvider } from './lib/posthog'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
)

